import React from "react";
import Modal from "react-bootstrap/Modal";
import {
  BsDownload,
  BsPaperclip,
  BsX,
} from "react-icons/bs";
import { LuForward } from "react-icons/lu";
import { LuReply } from "react-icons/lu";

export const ContactEmailModal = ({
  show,
  onHide,
  selectedEmail,
  downloadingAttachmentIndex,
  onDownloadAttachment,
  t,
  onReplyEmail,
  onForwardEmail,
}) => {
  const renderBody = () => {
    const body = selectedEmail?.body || t("No email body available.");

    if (body.trim().startsWith("<")) {
      return (
        <div
          className="contact-emails-body"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      );
    }

    return (
      <div className="contact-emails-body contact-emails-body-plain">
        {body}
      </div>
    );
  };

  const renderFieldRow = (label, value, placeholder = "") => (
    <div className="contact-email-reader-field-row">
      <span className="contact-email-reader-field-label">{label}</span>
      <span className="contact-email-reader-field-value">
        {value || placeholder}
      </span>
    </div>
  );

  const formattedDate = [selectedEmail?.date, selectedEmail?.time]
    .filter(Boolean)
    .join(" ");
  const attachments = selectedEmail?.attachments || [];

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="contact-email-reader-dialog"
      contentClassName="contact-email-reader-content"
    >
      <div className="contact-email-reader">
        <div className="contact-email-reader-header">
          <div className="contact-email-reader-subject">
            <span>{t("Subject")}</span>
            <strong>{selectedEmail?.subject || t("No Subject")}</strong>
          </div>

          <div className="contact-email-reader-actions">
            <button
              type="button"
              className="contact-email-reader-action-btn"
              onClick={() => onReplyEmail(selectedEmail)}
            >
              <LuReply />
              {t("Reply")}
            </button>

            <button
              type="button"
              className="contact-email-reader-action-btn"
              onClick={() => onForwardEmail(selectedEmail)}
            >
              <LuForward />
              {t("Forward")}
            </button>
          </div>

          <button
            type="button"
            className="contact-email-reader-close"
            onClick={onHide}
            aria-label={t("Close")}
          >
            <BsX />
          </button>
        </div>

        <div className="contact-email-reader-fields">
          {renderFieldRow(t("To"), selectedEmail?.to)}
          {renderFieldRow(t("Cc"), selectedEmail?.cc, "")}
          {renderFieldRow(t("From"), selectedEmail?.from)}
          {formattedDate && renderFieldRow(t("Date"), formattedDate)}
        </div>

        <div className="contact-email-reader-body">
          {attachments.length > 0 && (
            <div className="contact-emails-attachments">
              {attachments.map((file, index) => (
                <button
                  type="button"
                  key={index}
                  className="attachment-item"
                  disabled={
                    !file.attachmentUrl || downloadingAttachmentIndex === index
                  }
                  aria-busy={downloadingAttachmentIndex === index}
                  onClick={(event) => onDownloadAttachment(event, file, index)}
                  title={file.fileName || t("Download attachment")}
                >
                  <BsPaperclip />
                  <span className="attachment-file-name">
                    {file.fileName || t("Attachment")}
                  </span>
                  <BsDownload className="attachment-download-icon" />
                  {downloadingAttachmentIndex === index && (
                    <span className="attachment-download-text">
                      {t("Downloading")}
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}

          {renderBody()}
        </div>
      </div>
    </Modal>
  );
};
